export function serializeSVG(svg) {
  // filename = filename || 'Exported Chart'
  // filename = filename.split(' ').join('_')

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
  rect.setAttribute('width', '100%')
  rect.setAttribute('height', '100%')
  rect.setAttribute('fill', 'white')
  svg.prepend(rect)

  //get svg source.
  var serializer = new XMLSerializer()
  var source = serializer.serializeToString(svg)

  //add name spaces.
  if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
    source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"')
  }
  if (!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)) {
    source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"')
  }

  //add xml declaration
  source = '<?xml version="1.0" standalone="no"?>\r\n' + source
  return source
}

export function getDownloadUrl(source) {
  //convert svg source to URI data scheme.
  var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source)
  return url
  // var elem = document.createElement('a');
  // elem.href = url
  // elem.download = filename+'.svg';
  // elem.click();
  // window.URL.revokeObjectURL(url);
}
